export const enum ErrorCode {
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  BOOTSTRAP_FAILURE = 'BOOTSTRAP_FAILURE',
  MASTER_DATA_FAILURE = 'MASTER_DATA_FAILURE',
  TRANSLATION_FAILURE = 'TRANSLATION_FAILURE',
}

export interface AppError {
  readonly code: ErrorCode;
  readonly message: string;
  readonly status?: number;
  readonly correlationId?: string;
  readonly details?: Record<string, unknown>;
  readonly timestamp: string;
  readonly isFatal: boolean;
}
